export default class BaseSingleClass{
    //static _instance:any;
    static getInstance<T extends object>(this: new () => T):T{
        if(!(<any>this)._instance){
            (<any>this)._instance = new this();
        }
        return (<any>this)._instance
        /*if(!this._instance){
            this._instance = new this();
        }
        return this._instance as T*/
    }
    constructor() {
        if(this.constructor === BaseSingleClass){
            throw new Error("抽象类不能被实例化")
        }
    }
}